import mountApp from 'cfg/mountApp';
import Jobs     from './Vue/Jobs.vue';


export default (selector, options = {})=> {
  const vueOptions = {
    translationDomain: 'careers',
    components: { Jobs },
  };

  return mountApp({...options, ...vueOptions}, selector);
};
